import styled, { css } from 'styled-components';
import color from 'tinycolor2';
import { AnchorLink } from '@pearsontechnology/aero-components';

export const HoverActions = styled.div`
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 170px;
  padding-right: 8px;
  justify-content: flex-end;
  align-items: center;
  padding: 9px;
  background: linear-gradient(
    -90deg,
    ${(props) => props.theme['color.surface']},
    ${(props) => color(props.theme['color.surface']).setAlpha(0).toString()}
  );
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
export const ContainerWrapper = styled.div`
  display: block;
  position: relative;
  cursor: pointer;
  border: none;  
`;

export const KnowledgeMapEmptyChildContainerWrapper = styled.div`
background-color: ${(props) => props.theme['color.greyLighter']};
padding: 3px;
box-shadow: 0 0 4px 0 rgba(0,0,0,0.05), 0 1px 2px 0 rgba(0,0,0,0.05), 0 2px 4px 0 rgba(0,0,0,0.10), 0 2px 4px 0 rgba(0,0,0,0.10);
box-sizing: border-box;
margin-top: 5px;
margin-bottom: 5px;
`;

export const KnowledgeMapEmptyChildContainer = styled.div`
display: flex;
align-items: center;
padding: 9px;
position: relative;
box-sizing: border-box;
box-shadow: 0 0 4px 0 rgba(0,0,0,0.05), 0 1px 2px 0 rgba(0,0,0,0.05), 0 2px 4px 0 rgba(0,0,0,0.10);
cursor: pointer;
transition: box-shadow 0.3s ease;
border-radius: 4px;
background-color: ${(props) => props.theme['color.greyLighter']};
border-width: 2px;
border-style: dashed;
border-color: ${(props) => props.theme['color.greyDark']};
`;

export const KnowledgeMapEmptyChildNameContainer = styled.div`
  align-items: center;
  display: inline-block;
  line-height: 16px;
  margin-left: 6px;
  line-height: 18px;
  font-size: 14px;
  color: ${(props) => props.theme['color.text.body']};
  flex-grow: 1;
  text-align: center;
  font-style: italic
`;

export const EnablingObjectiveAddNewLink = styled(AnchorLink)`
  text-decoration-line: underline;
  font-weight:bold;
  span {
    border-bottom: none;
    box-shadow: none;
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 9px;
  position: relative;
  margin-bottom: 5px;
  box-sizing: border-box;
  box-shadow: 0 0 4px 0 rgba(0,0,0,0.05), 0 1px 2px 0 rgba(0,0,0,0.05), 0 2px 4px 0 rgba(0,0,0,0.10);
  cursor: pointer;
  transition: box-shadow 0.3s ease;
  border-radius: 4px;
  background-color: ${(props) => props.theme['color.surface']};
  border: none;

  &:hover,
  &:active,
  &:focus {
    box-shadow: 0 1px 12px 0 rgba(0, 0, 0, 0.1), 0 6px 16px 0 rgba(0, 0, 0, 0.16);
    z-index: 1;

    ${Actions} {
      display: flex;
    }
  }

  &:focus {
    box-shadow:
      0 1px 12px 0 rgba(0, 0, 0, 0.1), 0 6px 16px 0 rgba(0, 0, 0, 0.16),
      0 0 0 2px ${(props) => color(props.theme['color.primary']).setAlpha(0.4).toString()};
    background-color: ${(props) => props.theme['color.surface']};
    outline: 0;
  }

  ${(props) => props.selected && css`
    background-color: ${color(props.theme['color.primary']).setAlpha(0.2).toString()};
    box-shadow: inset 0 0 0 2px ${props.theme['color.primary']};
    background: ${color(props.theme['color.primary']).setAlpha(0.2).toString()};

    &:hover {
      box-shadow: inset 0 0 0 2px ${props.theme['color.primary']};

      ${HoverActions} {
        display: flex;
        top: 2px;
        right: 2px;
        bottom: 2px;
        background: linear-gradient(
          -90deg,
          ${color.mix(props.theme['color.primary'], props.theme['color.surface'], 80).toString()},
          ${color.mix(props.theme['color.primary'], props.theme['color.surface'], 80).setAlpha(0).toString()}
        );
      }
    }
  `}
`;

export const KnowledgeNameContainer = styled.div`
  align-items: center;
  display: inline-block;
  line-height: 16px;
  margin-left: 6px;
  line-height: 18px;
  font-size: 14px;
  color: ${(props) => props.theme['color.text.body']};
  flex-grow: 1;
`;

export const HumanCodingSchemeContainer = styled.span`
  padding: 1px 6px;
  margin-right: 6px;
  line-height: 14px;
  font-size: 12px;
  font-weight: bold;
  color: ${(props) => props.theme['color.text.body']};
  background-color: ${(props) => color(props.theme['color.text.body']).setAlpha(0.1).toString()};
  border-radius: 100px;
  letter-spacing: .8px;
`;

export const IconContainer = styled.div`
  flex-shrink: 0;
  align-self: center;
`;

export const WarningIconContainer = styled.span`
  margin-right: 5px;
`;
